<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Employee
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Training
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Trainers
      </h6>

      <div class="container-fluid">
        <div style="border: 0; padding: 0; min-height: 0" class="navbar background_color">
          <div class="d-flex">
            <b-input-group size="sm" style="width: 225px;">
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search"
                class="bdr-rad"
              />
            </b-input-group>
            <div style="margin-top: 11px" class="ms-2">
              <span class="custom-breadcrumb">
                Showing {{ currentPage }}-{{ currentPage * perPage }} of {{ totalRows }} items.
              </span>
            </div>
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else class="table-responsive">
              <b-table
                responsive
                class="table-hover"
                style="font-size: small"
                :items="trainers"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                head-variant="dark"
                :filter="filter"
                :filter-included-fields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                show-empty
                small
                @filtered="onFiltered"
              >
                <template #cell(tt_trainer_name)="row">
                  {{ row.item.tt_trainer_name }}
                </template>

                <template #cell(actions)="row">
                  <div class="dropdown">
                    <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu bdr-rad">
                      <a class="dropdown-item mouse-cursor" @click="viewItem(row.item.tt_id)">View</a>
                      <a class="dropdown-item mouse-cursor" @click="updateItem(row.item.tt_id)">Update</a>
                    </div>
                  </div>
                </template>
              </b-table>

              <b-col style="padding-left: 0" sm="7" md="2" class="my-1 mb-4">
                <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm" />
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: {
    TopNavbar,
    ContentFooter,
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      trainers: [],
      filter: null,
      filterOn: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      isLoading: true,
      fields: [
        { key: 'tt_trainer_name', label: 'Trainer Name', sortable: true },
        { key: 'designation', label: 'Designation', sortable: true },
        { key: 'contact_no', label: 'Contact No', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'department', label: 'Department', sortable: true },
        { key: 'actions', label: 'Actions', class: 'width-custom8' },
      ],
    };
  },
  mounted() {
    this.loadTrainers();
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    viewItem(id) {
      this.$router.push('/training/view?id=' + id);
    },
    updateItem(id) {
      this.$router.push('/training/update?id=' + id);
    },
    async loadTrainers() {
      try {
        const { data } = await axios.get('/training/index', {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-Type': 'application/json',
          },
        });
        this.trainers = data.all_data || [];
        this.totalRows = this.trainers.length;
      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.bdr-rad {
  border-radius: 12px;
}

.bdr-rad2 {
  border-radius: 15px;
}

.decoration {
  text-decoration: none;
  color: white !important;
}

.font1 {
  font-size: 13px !important;
}

.manage-boder {
  border-bottom: 2px solid #007bff;
  border-top: 2px solid #007bff;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}

.mouse-cursor {
  cursor: pointer;
}
</style>
